import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-108a2afc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-mb-lg" }
const _hoisted_2 = { class: "group-heading" }
const _hoisted_3 = { class: "text-body2" }
const _hoisted_4 = {
  key: 0,
  class: "row items-start q-py-md q-gutter-md justify-center"
}
const _hoisted_5 = { class: "text-grey-6" }
const _hoisted_6 = {
  style: {"max-height":"250px"},
  class: "row"
}
const _hoisted_7 = { class: "text-grey-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_table_cell_render = _resolveComponent("table-cell-render")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "bg-green-1 q-py-xs q-px-sm cursor-pointer",
        "data-test": "card-heading",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapsed && _ctx.toggleCollapsed(...args)))
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.groupHeading), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(`${_ctx.rows.length} ${_ctx.t('data.item', _ctx.rows.length)}`), 1)
      ]),
      (!_ctx.isCollapsed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
              return (_openBlock(), _createBlock(_component_q_card, {
                key: row,
                class: "cursor-pointer q-pa-md column items-start width--third no-wrap overflow-hidden",
                "data-test": "card",
                style: {"height":"200px"},
                onClick: ($event: any) => (_ctx.openModal(row))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, key) => {
                    return (_openBlock(), _createBlock(_component_q_card_section, {
                      key: key,
                      class: "q-pa-xs"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.columns[key].label[_ctx.localeString]), 1),
                        _createVNode(_component_table_cell_render, {
                          data: cell.toString(),
                          "data-type": _ctx.returnCellType(key.toString()),
                          filter: _ctx.filter
                        }, null, 8, ["data", "data-type", "filter"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.inspectData,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inspectData) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "q-pa-md modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center q-pa-none" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedRow, (cell, key) => {
                return (_openBlock(), _createBlock(_component_q_card_section, { class: "col-4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.columns[key].label[_ctx.localeString]), 1),
                    _createVNode(_component_table_cell_render, {
                      data: cell.toString(),
                      "data-type": _ctx.returnCellType(key.toString()),
                      filter: _ctx.filter,
                      "word-wrap": true
                    }, null, 8, ["data", "data-type", "filter"])
                  ]),
                  _: 2
                }, 1024))
              }), 256))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}